import { render, staticRenderFns } from "./createUserRole.vue?vue&type=template&id=46895a5b&scoped=true"
import script from "./createUserRole.vue?vue&type=script&lang=js"
export * from "./createUserRole.vue?vue&type=script&lang=js"
import style0 from "./createUserRole.vue?vue&type=style&index=0&id=46895a5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46895a5b",
  null
  
)

export default component.exports